import { createAction, props } from '@ngrx/store';
import { Order } from '@shared/models/order';

export const cancelOrderItem = createAction(
  '[Orders] Cancel Order Item',
  props<{ orderId: number; orderItemId: number; reason: string }>(),
);

export const cancelOrderItemSuccess = createAction('[Orders] Cancel Order Item Success', props<{ order: Order }>());

export const cancelOrderItemFailure = createAction('[Orders] Cancel Order Item Failure', props<{ error: any }>());
